var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,_vm._b({tag:"component",class:[_vm.$style.BaseIcon, _vm.$style[`BaseIcon--${_vm.size}`]],domProps:{"innerHTML":_vm._s(_vm.svg)}},'component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }